import { FC } from 'react'

import { View } from '@react-pdf/renderer'
import { PrintablePurchaseOrderInfoFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import Column from './Column'

type Props = PrintablePurchaseOrderInfoFragment

const Info: FC<Props> = ({ vendor, legalEntity }) => {
  const formatAddress = (lines: Array<string | undefined | null>) => {
    const filtered = lines.filter(Boolean)
    return filtered.length > 0 ? filtered.join(', ') : undefined
  }

  return (
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: '#F4F4F5',
        padding: 16,
        borderRadius: 4,
      }}
    >
      {vendor && (
        <Column
          title={i18n.t('procurement.purchase_orders.pdf.vendor')}
          name={vendor?.legalName}
          nif={vendor?.taxId}
          address1={formatAddress([vendor.address.line1, vendor.address.line2])}
          address2={formatAddress([
            vendor.address.postalCode,
            vendor.address.city,
            vendor.address.countryCode,
          ])}
        />
      )}
      <Column
        title={i18n.t('procurement.purchase_orders.pdf.requester')}
        name={legalEntity.legalName}
        nif={legalEntity.tin}
        address1={formatAddress([legalEntity.addressLine1, legalEntity.addressLine2])}
        address2={formatAddress([legalEntity.postalCode, legalEntity.city, legalEntity.country])}
        phoneNumber={legalEntity.invoiceePhoneNumber}
        email={legalEntity.invoiceePhoneNumber}
      />
    </View>
  )
}

export default Info
